import BaseTableRow from '@tiptap/extension-table-row'

export const TableRow = BaseTableRow.extend({
  allowGapCursor: false,
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: 'isolation-auto',
      },
    }
  },
})
